import { useEffect } from 'react';
import './CitibotChat.scss';

const CitibotChat = () => {
    useEffect(() => {
        // Load CitiBot script
        const script = document.createElement('script');
        script.id = 'citibot-chatscript';
        script.type = 'text/javascript';
        script.src = 'https://webchat-ui.citibot.net/script.js?account_id=68ac16f69615b67e81037dc6';
        script.async = true;

        document.body.appendChild(script);

        // Cleanup function to remove script when component unmounts
        return () => {
            const existingScript = document.getElementById('citibot-chatscript');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        };
    }, []);

    return null;
};

export default CitibotChat;
